import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  text-align: center;
  display: inline-block;

  &.current {
    margin: 0 auto;
    display: block;
  }
`;

const Image = styled.img`
  display: block;
  max-width: 100px;
  width: 100%;

  &.current {
    margin: 0 auto;
  }
`;

export type BadgeInfo = {
  name: string;
  image_path: string;
  unlock_level: number;
};

interface BadgeProps {
  badgeInfo: BadgeInfo;
  current?: boolean;
}

const Badge: FC<BadgeProps> = ({ badgeInfo, current }) => {
  let showBadgeName = true;

  if (current) {
    showBadgeName = false;
  }

  const image = new URL(`./badges/${badgeInfo.image_path}`, import.meta.url).href;

  return (
    <Container className={current ? 'current' : ''}>
      <Image alt={badgeInfo.name + '_badge'} className={current ? 'current' : ''} src={image}></Image>

      {showBadgeName && <div className="progress_map_badge_text">{badgeInfo.name}</div>}
    </Container>
  );
};

export default Badge;
